/* eslint-disable react-hooks/exhaustive-deps */
import Layout from "../../layout/Layout";
import { useState, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";
import { ByTheHourQuotation } from "./ByTheHourQuotation";
import { SpecifiedDestinationQuotation } from "./SpecifiedDestinationQuotation";
import { getAvailableVehicle } from "../../../actions/admin/booking";
import { getMeetAssistPrice } from "../../../actions/admin/settings"
import moment from "moment";
import AdminInput from "../components/AdminInput";
import AdminTextArea from "../components/AdminTextArea";
import AdminSelect from "../components/AdminSelect";
import { postQuotation, duplicateBooking, postEditQuotation, addStandaloneItems } from "../../../actions/admin/quotation";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import AdminInputDatePicker from "../components/AdminInputDatePicker";
import { useEffect } from "react";
import AdminModal from "../components/AdminModal";
import debounce from 'lodash/debounce';
import {
  BackAltIcon,
  RadioSelectedIcon,
  RadioUnselectedIcon,
  ReferenceIcon,
  AddCircleIcon,
  FlightNumberIcon,
  TrainIcon,
  CalendarAltIcon,
  CloseIcon,
  CloseCircleIcon,
  PlusIcon,
} from "../../icons";

const Transfer = () => {
  const [errorText, setErrorText] = useState("");
  const { quotationId } = useParams();
  const location = useLocation();
  const { quotationInformation } = location.state || {};
  const [errorModal, setErrorModal] = useState(false);
  const closeErrorModal = () => setErrorModal(false);
  const openErrorModal = () => setErrorModal(true);
  const history = useHistory();
  const [bookingData, setBookingData] = useState(null);
  const [bookingType, setBookingType] = useState("byTheHour");
  const [editFormAvailableVehicle, setEditFormAvailableVehicle] = useState(null);
  const [loadingAddTransfer, setLoadingAddTransfer] = useState(false);
  const [loadingSearchAvailableVehicle, setLoadingSearchAvailableVehicle] = useState(false);
  const [availableVehicleData, setAvailableVehicleData] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [meetAssistPrice, setMeetAssistPrice] = useState({
    pickup: {
      meetAssistBasePrice: 0,
      vipMeetAssistBasePrice: 0,
      vipMeetAssistAdditionalPrice: 0,
    },
    dropoff: {
      meetAssistBasePrice: 0,
      vipMeetAssistBasePrice: 0,
      vipMeetAssistAdditionalPrice: 0,
    }
  })

  useEffect(() => {
    if (localStorage.getItem("editTransferData")) {
      handleEditMethod();
    }
  }, []);

  useEffect(() => {
    if (availableVehicleData) {
      fetchMeetAssistPrice();
    }
  }, [availableVehicleData]);

  const [additionalInformation, setAdditionalInformation] = useState({
    pronounce: "Mr. ",
    passengerName: null,
    pickupFlightNumber: null,
    dropoffFlightNumber: null,
    pronounceNameBoard: null,
    nameBoard: null,
    meetAssist: [
      {
        meetAssistType: "arrival",
        meetAssistName: "none",
        meetAssistPrice: 0,
      },
      {
        meetAssistType: "departure",
        meetAssistName: "none",
        meetAssistPrice: 0,
      },
    ],
    childSeat: [
      {
        childSeatType: "Baby",
        childSeatCount: 0,
      },
      {
        childSeatType: "Toddler",
        childSeatCount: 0,
      },
      {
        childSeatType: "Child",
        childSeatCount: 0,
      },
      {
        childSeatType: "Infant",
        childSeatCount: 0,
      },
    ],
    childSeatPrice: 0,
  });

  const checkNightHours = async (pickupTime, dropoffTime) => {
    const pickupDateTime = new Date(pickupTime).getUTCHours();
    const dropoffDateTime = new Date(dropoffTime).getUTCHours();

    return {
      pickup: (pickupDateTime >= 22 || pickupDateTime < 6),
      dropoff: (dropoffDateTime >= 22 || dropoffDateTime < 6)
    };
  }

  const fetchMeetAssistPrice = async () => {
    try {
      const { meetAssistBasePrice, vipMeetAssistBasePrice, vipMeetAssistAdditionalPrice } = await getMeetAssistPrice();

      const { pickup, dropoff } = await checkNightHours(
        new Date(`${availableVehicleData?.travelDate}T${availableVehicleData?.pickupTime}:00Z`).toISOString(),
        availableVehicleData.customerDropoffDateTime
      );

      console.log("checknighthours", { pickup, dropoff })

      if (pickup || dropoff) {
        setMeetAssistPrice({
          pickup: {
            meetAssistBasePrice: pickup ? Math.ceil(meetAssistBasePrice * 1.25) : meetAssistBasePrice,
            vipMeetAssistBasePrice: pickup ? Math.ceil(vipMeetAssistBasePrice * 1.25) : vipMeetAssistBasePrice,
            vipMeetAssistAdditionalPrice: pickup ? Math.ceil(vipMeetAssistAdditionalPrice * 1.25) : vipMeetAssistAdditionalPrice,
          },
          dropoff: {
            meetAssistBasePrice: dropoff ? Math.ceil(meetAssistBasePrice * 1.25) : meetAssistBasePrice,
            vipMeetAssistBasePrice: dropoff ? Math.ceil(vipMeetAssistBasePrice * 1.25) : vipMeetAssistBasePrice,
            vipMeetAssistAdditionalPrice: dropoff ? Math.ceil(vipMeetAssistAdditionalPrice * 1.25) : vipMeetAssistAdditionalPrice,
          }
        })
      } else {
        setMeetAssistPrice({
          pickup: {
            meetAssistBasePrice: meetAssistBasePrice,
            vipMeetAssistBasePrice: vipMeetAssistBasePrice,
            vipMeetAssistAdditionalPrice: vipMeetAssistAdditionalPrice,
          },
          dropoff: {
            meetAssistBasePrice: meetAssistBasePrice,
            vipMeetAssistBasePrice: vipMeetAssistBasePrice,
            vipMeetAssistAdditionalPrice: vipMeetAssistAdditionalPrice,
          }
        });
      }
    } catch (error) {
      console.error("Error fetching meet assist price:", error);
    }
  };

  const handleEditMethod = () => {
    const editData = JSON.parse(localStorage.getItem("editTransferData"));

    // Handle Booking Type 
    handleBookingType(editData?.bookingType);
    setEditFormAvailableVehicle({
      pickupLocation: editData?.pickupLocation,
      dropoffLocations: editData?.destinations,
      duration: editData?.duration,
      travelDate: editData?.travelDate,
      pickupTimeRaw: editData?.pickupTime,
      estpPickupTime: null,
      travelArea: editData?.bookingInfo[0].travelArea,
      luggage: {
        cabinSize: editData?.luggage[1].luggagecount,
        checkinSize: editData?.luggage[0].luggagecount,
      },
      pax: {
        adult: editData?.pax[0].paxcount,
        child: editData?.pax[1].paxcount,
        toddler: editData?.pax[2].paxcount,
        baby: editData?.pax[3].paxcount,
      },
      byTheHourBook: editData?.bookingType === "byTheHour" ? true : false,
      bookingType: editData?.bookingType === "byTheHour" ? "byTheHour" : "specifiedDestination",
      // TODO : Make this 2 key value valid (false, false) is not 
      isAirportTransfer: editData?.isAirportTransfer,
      isFromAirport: editData?.isFromAirport,
      isToAirport: editData?.isToAirport,
      isStationTransfer: editData?.isStationTransfer,
      isFromStation: editData?.isFromStation,
      isToStation: editData?.isToStation,
    });

    const result = (([first, ...rest]) => [first, rest.join(" ")])(editData?.pickupSign.split(" "));

    const totalChildSeatCount = editData?.childSeat.reduce(
      (sum, seat) => sum + seat.childSeatCount,
      0
    );

    setAdditionalInformation({
      pronounce: editData?.passengerPronounced,
      passengerName: editData?.passengerName,
      pickupFlightNumber: editData?.pickupFlightNo,
      dropoffFlightNumber: editData?.dropoffFlightNo,
      pronounceNameBoard: result[0],
      nameBoard: result[1],
      meetAssist: [
        {
          meetAssistType: editData?.meetAssist[0]?.meetAssistType,
          meetAssistName: editData?.meetAssist[0]?.meetAssistName,
          meetAssistPrice: editData?.meetAssist[0]?.meetAssistPrice,
        },
        {
          meetAssistType: editData?.meetAssist[1]?.meetAssistType,
          meetAssistName: editData?.meetAssist[1]?.meetAssistName,
          meetAssistPrice: editData?.meetAssist[1]?.meetAssistPrice,
        },
      ],
      childSeat: [
        {
          childSeatType: "Baby",
          childSeatCount: editData?.childSeat[0]?.childSeatCount,
        },
        {
          childSeatType: "Toddler",
          childSeatCount: editData?.childSeat[1]?.childSeatCount,
        },
        {
          childSeatType: "Child",
          childSeatCount: editData?.childSeat[2]?.childSeatCount,
        },
        {
          childSeatType: "Infant",
          childSeatCount: editData?.childSeat[3]?.childSeatCount,
        },
      ],
      childSeatPrice: totalChildSeatCount * 1100,
    });

    setNote(editData.message ? editData.message[0]?.note || "" : ""); // TODO: TBD (key missing )

  }

  const handleBookingType = (value) => {
    setBookingData(null);
    setEditFormAvailableVehicle(null);
    setAvailableVehicleData(null);
    setVehicles([]);
    setAdditionalInformation({
      pronounce: "Mr. ",
      passengerName: null,
      pickupFlightNumber: null,
      dropoffFlightNumber: null,
      pronounceNameBoard: null,
      nameBoard: null,
      meetAssist: [
        {
          meetAssistType: "arrival",
          meetAssistName: "none",
          meetAssistPrice: 0,
        },
        {
          meetAssistType: "departure",
          meetAssistName: "none",
          meetAssistPrice: 0,
        },
      ],
      childSeat: [
        {
          childSeatType: "Baby",
          childSeatCount: 0,
        },
        {
          childSeatType: "Toddler",
          childSeatCount: 0,
        },
        {
          childSeatType: "Child",
          childSeatCount: 0,
        },
        {
          childSeatType: "Infant",
          childSeatCount: 0,
        },
      ],
      childSeatPrice: 0,
    });

    setBookingType(value);
  };

  const PRONOUNCE = [
    {
      label: "Mr.",
      value: "Mr.",
    },
    {
      label: "Ms.",
      value: "Ms.",
    },
    {
      label: "Mrs.",
      value: "Mrs.",
    },
    {
      label: "Mr./Ms.",
      value: "Mr./Ms.",
    },
  ];

  const PRONOUNCE_BOARD = [
    {
      label: "Mr.",
      value: "Mr.",
    },
    {
      label: "Ms.",
      value: "Ms.",
    },
    {
      label: "Mrs.",
      value: "Mrs.",
    },
    {
      label: "No Honorific",
      value: " ",
    },
  ];

  const [addTransferType, setAddTransferType] = useState("one_time"); // one_time && recuring
  const handleChangeAddTransferType = (type) => setAddTransferType(type);

  const [recurringTravelDates, setRecurringTravelDates] = useState([""]);
  const handleSelectTravelDate = (date, index) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setRecurringTravelDates((prevDates) => {
      if (prevDates[index] !== undefined) {
        const updatedDates = [...prevDates];
        updatedDates[index] = formattedDate;
        return updatedDates;
      }
      return prevDates;
    });
  };
  const addReccuringTravelDate = () => {
    setRecurringTravelDates([...recurringTravelDates, ""]);
  }

  const removeReccuringTravelDate = (index) => {
    if (recurringTravelDates.length > 1) {
      setRecurringTravelDates((recurringTravelDates) => [
        ...recurringTravelDates.slice(0, index),
        ...recurringTravelDates.slice(index + 1),
      ]);
    }
  }

  const debouncedCheckAvailability = useCallback(
    debounce(async (data) => {
      handleLoadingSearchAvailableVehicle(true);
      setVehicles([]);
      if (data) {
        data.pickupTime = data.pickupTimeRaw
        data.travelDate = moment
          .utc(data.travelDate, "YYYY-MM-DD")
          .local()
          .format("YYYY-MM-DD");
        data.flightTracking = (data.flightTracking || data.isAirportTransfer)
        data.fromQuotation = true;
        var res = await getAvailableVehicle(data);
        setBookingData(data);
        setAvailableVehicleData(res.data);
        convertVehicleOptions(res.data);
        handleLoadingSearchAvailableVehicle(false);

        if (localStorage.getItem("editTransferData")) { // is edit
          handleSetSelectedVehicleEditData(res.data);
        }
      }
    }, 500),
    []
  )
  // submit
  const handleSearchAvailableVehicles = async (data) => {
    handleLoadingSearchAvailableVehicle(true);
    setVehicles([]);
    if (data) {
      data.pickupTime = data.pickupTimeRaw
      data.travelDate = moment
        .utc(data.travelDate, "YYYY-MM-DD")
        .local()
        .format("YYYY-MM-DD");
      data.flightTracking = (data.flightTracking || data.isAirportTransfer)
      data.fromQuotation = true;
      var res = await getAvailableVehicle(data);
      setBookingData(data);
      setAvailableVehicleData(res.data);
      convertVehicleOptions(res.data);
      handleLoadingSearchAvailableVehicle(false);

      if (localStorage.getItem("editTransferData")) { // is edit
        handleSetSelectedVehicleEditData(res.data);
      }
    }
  };

  const handleSetSelectedVehicleEditData = (data) => {
    const dataEdit = JSON.parse(localStorage.getItem("editTransferData"));

    var v = []
    for (let index = 0; index < dataEdit?.bookingInfo.length; index++) {
      const vehcileID = dataEdit.bookingInfo[index].vehicleTypeID;
      const vo = data.availableVehicleTypes.map((vehicle) => ({
        label: vehicle.typename,
        value: vehicle._id,
        info: vehicle,
      }));
      const vehicleInfo = vo.find((vo) => vo.value === vehcileID)?.info;
      v.push(vehicleInfo);
    }
    setVehicles(v);
  }

  const [vehicleOptions, setVehicleOptions] = useState([]);

  const convertVehicleOptions = (data) => {
    const selectOptions = data.availableVehicleTypes.map((vehicle) => ({
      label: `${vehicle.typename} - ${vehicle.price.toLocaleString()} JPY`,
      value: vehicle._id,
      info: vehicle,
    }));
    setVehicles([null]);
    setVehicleOptions(selectOptions);
  };

  const handleOnSelectVehicle = (selectOption, index) => {
    setVehicles((vehicles) => [
      ...vehicles.slice(0, index),
      selectOption.info,
      ...vehicles.slice(index + 1),
    ]);
  };

  const handleAddVehicle = () => {
    setVehicles((vehicles) => [...vehicles, null]);
  };

  const handleLoadingSearchAvailableVehicle = (value) => {
    setLoadingSearchAvailableVehicle(value);
  };

  const handleRemoveVehicle = (index) => {
    if (vehicles.length > 1) {
      setVehicles((vehicles) => [
        ...vehicles.slice(0, index),
        ...vehicles.slice(index + 1),
      ]);
    }
  };

  // Additional Information Handler
  const handlePronouncePassangerName = (selectedOption) => {
    setAdditionalInformation((additionalInformation) => ({
      ...additionalInformation,
      pronounce: selectedOption.value,
    }));
  };

  const handlePassangerName = (e) => {
    setAdditionalInformation((additionalInformation) => ({
      ...additionalInformation,
      passengerName: e.target.value,
    }));
  };

  const handlePickupFlightNumber = (e) => {
    setAdditionalInformation((additionalInformation) => ({
      ...additionalInformation,
      pickupFlightNumber: e.target.value,
    }));
  };

  const handleDropoffFlightNumber = (e) => {
    setAdditionalInformation((additionalInformation) => ({
      ...additionalInformation,
      dropoffFlightNumber: e.target.value,
    }));
  };

  const handlePronounceNameBoard = (selectedOption) => {
    setAdditionalInformation((additionalInformation) => ({
      ...additionalInformation,
      pronounceNameBoard: selectedOption.value,
    }));
  };

  const handleNameBoard = (e) => {
    setAdditionalInformation((additionalInformation) => ({
      ...additionalInformation,
      nameBoard: e.target.value,
    }));
  };

  const handleMeetAndAssist = (type, data) => {
    setAdditionalInformation((prevState) => {
      const updatedMeetAssist = [...prevState.meetAssist];

      switch (type) {
        case "arrival":
          updatedMeetAssist[0] = { ...updatedMeetAssist[0], ...data }; // Merge data for "arrival"
          break;

        case "departure": // Corrected typo
          updatedMeetAssist[1] = { ...updatedMeetAssist[1], ...data }; // Merge data for "departure"
          break;

        default:
          console.warn(`Unhandled type: ${type}`);
          return prevState; // Return unchanged state for invalid type
      }

      return {
        ...prevState,
        meetAssist: updatedMeetAssist,
      };
    });
  };

  const handleChildSeat = (type, total) => {
    setAdditionalInformation((prevState) => {
      const updatedChildSeat = [...prevState.childSeat];
      switch (type) {
        case "Infant":
          updatedChildSeat[0] = {
            ...updatedChildSeat[0],
            childSeatCount: total,
          };
          break;

        case "Toddler":
          updatedChildSeat[1] = {
            ...updatedChildSeat[1],
            childSeatCount: total,
          };
          break;

        case "Child":
          updatedChildSeat[2] = {
            ...updatedChildSeat[2],
            childSeatCount: total,
          };
          break;

        case "Baby":
          updatedChildSeat[3] = {
            ...updatedChildSeat[3],
            childSeatCount: total,
          };
          break;

        default:
          console.warn(`Unhandled type: ${type}`);
          return prevState;
      }

      const totalChildSeatCount = updatedChildSeat.reduce(
        (sum, seat) => sum + seat.childSeatCount,
        0
      );

      return {
        ...prevState,
        childSeat: updatedChildSeat,
        childSeatPrice: totalChildSeatCount * 1100,
      };
    });
  };

  const [note, setNote] = useState(null);

  const handleNote = (e) => {
    setNote(e.target.value);
  };

  // submit transfer
  const handleSubmitConfirm = async () => {
    if (vehicles.length > 0) {
      handleSubmitTransfer((recurringTravelDates.length > 0 && addTransferType === "recurring") ? true : false);
    }
  };

  const handleSubmitTransfer = async (recurring) => {
    try {
      setLoadingAddTransfer(true);

      var bookings = [];
      var bookingInfo = [];

      const filteredVehicles = vehicles.filter((item) => item !== null);
      // return;
      for (let i = 0; i < filteredVehicles.length; i++) {
        var data = {
          vehicleTypeName: filteredVehicles[i].typename,
          vehicleTypeID: filteredVehicles[i]._id,
          pax: [
            {
              paxtype: "Adult",
              paxcount: 0,
            },
            {
              paxtype: "Child",
              paxcount: 0,
            },
            {
              paxtype: "Toddler",
              paxcount: 0,
            },
            {
              paxtype: "Baby",
              paxcount: 0,
            },
          ],
          luggage: [
            {
              luggagetype: "CHECK-IN SIZE",
              luggagecount: 0,
            },
            {
              luggagetype: "CABIN SIZE",
              luggagecount: 0,
            },
          ],
          baseprice: filteredVehicles[i].baseprice,
          hourlyprice: filteredVehicles[i].hourlyprice,
          tollFare: filteredVehicles[i].tollFare,
          travelArea: bookingData.travelArea,
          travelAreaPrice: filteredVehicles[i].travelAreaPrice,
          longDistanceSurcharge: filteredVehicles[i].longDistanceSurcharge,
          total: filteredVehicles[i].price,
          childSeat: [
            {
              childSeatType: "Infant",
              childSeatCount: 0,
            },
            {
              childSeatType: "Toddler",
              childSeatCount: 0,
            },
            {
              childSeatType: "Child",
              childSeatCount: 0,
            },
          ],
          childSeatPrice: 0,
          vehicle: null,
        };
        bookingInfo.push(data);
      }

      let bookingField = {
        travelDate: availableVehicleData.travelDate,
        pickupTime: availableVehicleData.pickupTime,
        pax: bookingData.pax,
        luggage: bookingData.luggage,
        bookingType: bookingData.bookingType,
        isAirportTransfer: bookingData.isAirportTransfer,
        isFromAirport: bookingData.isFromAirport,
        isToAirport: bookingData.isToAirport,
        isStationTransfer: bookingData.isStationTransfer,
        isFromStation: bookingData.isFromStation,
        isToStation: bookingData.isToStation,
        meetAssist: additionalInformation.meetAssist,
        isManyPeople: false,
        bookingInfo: bookingInfo,
        passengerName: additionalInformation.passengerName,
        passengerPronounced: additionalInformation.pronounce,
        childSeat: additionalInformation.childSeat,
        dropoffFlightNo: additionalInformation.dropoffFlightNumber,
        pickupFlightNo: additionalInformation.pickupFlightNumber,
        pickupSign: additionalInformation.pronounceNameBoard + ' ' + additionalInformation.nameBoard,
        noteList: note
          ? [
            {
              note: note,
            },
          ]
          : null,
        longDistance: bookingData.longDistance,
        totalDistance: bookingData.totalDistance,
        driverAccomodation: bookingData.driverAccomodation,
      };

      let destinations = [];
      bookingData.dropoffLocations.map((v) => {
        destinations.push(v?.value);
      })

      bookingField.destinations = destinations;
      if (bookingData.pickupLocation) {
        bookingField.pickupLocation = bookingData?.pickupLocation?.value;
      } else {
        bookingField.pickupLocation = null;
      }

      if (bookingData.bookingType === "byTheHour") {
        bookingField.duration = bookingData.usageDuration;
        bookingField.travelArea = bookingData.travelArea;
      }

      bookings.push(bookingField);

      var formData;

      if (localStorage.getItem("editTransferData")) {
        var editData = JSON.parse(localStorage.getItem("editTransferData"));
        formData = {
          booking: bookings[0],
        };
      } else {
        formData = {
          bookings: bookings,
        };
      }

      if (quotationId) {
        formData.id = quotationId;
        formData.quotationID = quotationInformation.quotationID;
        formData.quotationNumber = quotationInformation.bookingReference;
        formData.issueDate = moment
          .utc(quotationInformation.issueDate, "YYYY-MM-DD")
          .local()
          .format("YYYY-MM-DD");
        formData.expiredDate = moment
          .utc(quotationInformation.validUntil, "YYYY-MM-DD")
          .local()
          .format("YYYY-MM-DD");
        formData.notes = "";
      }
      var res;
      if (localStorage.getItem("editTransferData")) {
        var editData = JSON.parse(localStorage.getItem("editTransferData"));
        res = await postEditQuotation(formData, quotationId, editData._id);
      } else {
        res = await postQuotation(formData);

        // When creating a brand-new quotation (no quotationId yet), carry over any
        // standalone (non-booking) items that were added on the create page before
        // the first transfer — otherwise they'd be lost once the quotation exists.
        if (!quotationId) {
          try {
            const draft = JSON.parse(localStorage.getItem("quotationData") || "null");
            const pendingStandalone = draft?.localStandaloneGroups;
            if (Array.isArray(pendingStandalone) && pendingStandalone.length > 0) {
              await addStandaloneItems({ quotationId: res.data._id, groups: pendingStandalone });
              // They now live on the quotation; drop them from the local draft.
              localStorage.setItem(
                "quotationData",
                JSON.stringify({ ...draft, localStandaloneGroups: [] })
              );
            }
          } catch (standaloneError) {
            console.error("Failed to carry over standalone items:", standaloneError);
          }
        }
      }

      setLoadingAddTransfer(false);

      // hit recurring
      if (recurring) {
        var bookingId = res.data.bookings[0]._id;
        var qId = res.data._id;
        const filteredTravelDates = recurringTravelDates.filter((date) => date.trim() !== "");
        if (filteredTravelDates.length > 0) {

          var resDuplicate = await duplicateBooking({
            quotationId: qId,
            bookingId: bookingId,
            duplicateDate: filteredTravelDates,
          });
        }
      }

      history.push("/admin/quotations/create/" + res.data._id);
    } catch (error) {
      setErrorText(error?.message);

      openErrorModal();
    }
    finally {
      setLoadingAddTransfer(false);
    }
  };

  const totalMaxPessanger = vehicles.reduce(
    (acc, item) => acc + parseInt(item?.maxpassenger ?? 0, 10),
    0
  );

  const totalMaxLuggage = vehicles.reduce(
    (acc, item) => acc + parseInt(item?.maxluggages ?? 0, 10),
    0
  );

  return (
    <>
      <Layout>
        <main
          className="col-md-9 ms-sm-auto col-lg-10 px-md-4 py-4 w-100"
          style={{ backgroundColor: "#F6F6F6" }}
        >
          <div id="header" className="mb-3">
            <div className="d-inline-flex align-items-center gap-2 pointer" onClick={() => history.push(quotationId ? `/admin/quotations/create/${quotationId}` : "/admin/quotations/create", quotationId ? undefined : { keepDraft: true })}>
              <BackAltIcon
                width={"10px"}
                height={"10px"}
              />
              <p className="noto m-0">Back</p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <h2 className="mt-2">Transfer</h2>
            </div>
          </div>
          <div id="body">
            <div className="bg-white rounded p-3">
              <div className="mb-5">
                <h5>1. Basic Information</h5>
                <div className="d-flex gap-3 my-3">
                  <div
                    className={`${bookingType === "byTheHour"
                      ? "border border-gold"
                      : "border"
                      } rounded px-2 d-flex align-items-center`}
                    style={{ height: "50px" }}
                  >
                    <div className="d-flex gap-3 align-items-center px-3">
                      {bookingType === "byTheHour"
                        ? <RadioSelectedIcon />
                        : <RadioUnselectedIcon />}
                      <p
                        className={`m-0 p-0 pointer ${bookingType === "byTheHour" && "fw-bold"
                          } `}
                        onClick={() => handleBookingType("byTheHour")}
                      >
                        Charter/By The Hour
                      </p>
                    </div>
                  </div>
                  <div
                    className={`${bookingType === "specifiedDestination"
                      ? "border border-gold"
                      : "border"
                      } rounded px-2 d-flex align-items-center`}
                    style={{ height: "50px" }}
                  >
                    <div className="d-flex gap-3 align-items-center px-3">
                      {bookingType === "specifiedDestination"
                        ? <RadioSelectedIcon />
                        : <RadioUnselectedIcon />}
                      <p
                        className={`m-0 p-0 pointer ${bookingType === "specifiedDestination" && "fw-bold"
                          } `}
                        onClick={() => handleBookingType("specifiedDestination")}
                      >
                        Airport Transfer/Specified Destination
                      </p>
                    </div>
                  </div>
                </div>

                {bookingType === "byTheHour" && (
                  <ByTheHourQuotation
                    searchAvailableVehicles={debouncedCheckAvailability}
                    editFormAV={editFormAvailableVehicle}
                  />
                )}

                {bookingType === "specifiedDestination" && (
                  <SpecifiedDestinationQuotation
                    searchAvailableVehicles={debouncedCheckAvailability}
                    editFormAvailableVehicle={editFormAvailableVehicle}
                  />
                )}
              </div>
              <div className="mb-5">
                <h5 className="mt-4">2. Vehicle Selection</h5>
                {
                  vehicles.filter(value => value !== null).length > 0
                    ? parseInt(bookingData?.luggage?.cabinSize + bookingData?.luggage?.checkinSize) > totalMaxLuggage || parseInt(bookingData?.pax?.adult + bookingData?.pax?.child + bookingData?.pax?.toddler + bookingData?.pax?.baby) > totalMaxPessanger
                      ? <p className="text-danger">The number of passengers or the luggage doesn't fit. Please add another vehicle.</p>
                      : <></>
                    : <></>
                }

                <div className="row mt-3">
                  {vehicles.map((vehicle, index) => (
                    <div className="tw:w-full tw:md:!w-1/3 tw:mb-3" key={index}>
                      <p className="tw:mb-2">Vehicle #{index + 1}</p>

                      <div className="tw:flex tw:items-start tw:gap-2">
                        <div className="tw:flex-1">
                          <AdminSelect
                            mb="mb-0"
                            options={vehicleOptions}
                            onChange={(selectedOption) =>
                              handleOnSelectVehicle(selectedOption, index)
                            }
                            value={{
                              label: vehicle?.typename
                                ? `${vehicle.typename} - ${vehicle.price?.toLocaleString()} JPY`
                                : "-",
                              value: vehicle?._id,
                              info: vehicle,
                            }}
                          />
                        </div>

                        {index > 0 && (
                          <button
                            type="button"
                            onClick={() => handleRemoveVehicle(index)}
                            className="
                              tw:flex
                              tw:!items-center
                              tw:!justify-center
                              tw:w-10
                              tw:h-12
                              tw:rounded
                              tw:border
                              tw:border-[#E8E8E8]
                              tw:bg-white
                              tw:hover:bg-gray-50
                            "
                          >
                            <CloseIcon size={16} />
                          </button>
                        )}
                      </div>

                      {vehicle && (
                        <div
                          className="
                            tw:mt-2
                            tw:p-3
                            tw:rounded
                            tw:bg-[#FFF8E8]
                          "
                        >
                          <div className="tw:flex tw:justify-between tw:items-start tw:gap-4">
                            <div className="tw:flex-1">
                              <p className="tw:text-[10px] tw:font-bold tw:mb-2">
                                DETAILS
                              </p>

                              <ul className="tw:list-disc tw:pl-5 tw:mb-0 tw:text-sm">
                                <li>
                                  From {vehicle.baseprice.toLocaleString()} JPY | min.{" "}
                                  {vehicle.basepricehours} hours
                                </li>
                                <li>Up to {vehicle.maxpassenger} Pax</li>
                                <li>Up to {vehicle.maxluggages} suitcases</li>
                              </ul>
                            </div>

                            <button
                              type="button"
                              className="
                                tw:flex
                                tw:items-center
                                tw:gap-2
                                tw:px-4
                                tw:py-3
                                tw:rounded
                                tw:bg-[#F4E3A3]
                                tw:whitespace-nowrap
                              "
                            >
                              <span className="tw:font-bold tw:underline">
                                Reference
                              </span>

                              <ReferenceIcon />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {loadingSearchAvailableVehicle ? (
                  <p className="text-center">Loading</p>
                ) : vehicles.length > 0 ? (
                  <button
                    className="btn bg-dark  rounded"
                    onClick={handleAddVehicle}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <AddCircleIcon />
                      <p className="m-0 text-white">Add Vehicle</p>
                    </div>
                  </button>
                ) : (
                  <p className="text-center">
                    * Fill all search form to get vehicles
                  </p>
                )}
              </div>
              <div className="mb-5">
                <h5 className="mt-4">3. Additional Information</h5>
                {/* AIRPORT TRANSFER */}
                {
                  (bookingData?.isAirportTransfer || bookingData?.isStationTransfer) && (
                    <>
                      {(bookingData?.isFromAirport || bookingData?.isFromStation) && (
                        <div className="mt-3">
                          <>
                            <p className="mb-2">{bookingData?.isFromAirport ? "Pickup Flight Number" : "Pickup Train Number"}</p>
                            <AdminInput
                              placeholder={bookingData?.isFromAirport ? "Pickup Flight Number" : "Pickup Train Number"}
                              prefixIcon={bookingData?.isFromAirport ? <FlightNumberIcon /> : <TrainIcon />}
                              value={additionalInformation?.pickupFlightNumber}
                              onChange={handlePickupFlightNumber}
                            />
                          </>

                          <p className="mb-2">Add-on Meet & Assist Services</p>
                          <div className="row mb-2">
                            {/* NONE */}
                            <div className="col-4 ">
                              <div
                                className="border-gold rounded p-3 pointer"
                                style={{ height: "100px" }}
                                onClick={() =>
                                  handleMeetAndAssist("arrival", {
                                    meetAssistType: "arrival",
                                    meetAssistName: "none",
                                    meetAssistPrice: 0,
                                  })
                                }
                              >
                                <div className="d-flex gap-2 align-items-center h-100">
                                  {additionalInformation.meetAssist[0]
                                      .meetAssistName === "none"
                                    ? <RadioSelectedIcon />
                                    : <RadioUnselectedIcon />}
                                  <div className="col">
                                    <p className="fw-bold m-0">None</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* MEET ASSIST */}
                            <div className="col-4 ">
                              <div
                                className="border-gold rounded p-3 pointer"
                                style={{ height: "100px" }}
                                onClick={() =>
                                  handleMeetAndAssist("arrival", {
                                    meetAssistType: "arrival",
                                    meetAssistName: "meetAssist",
                                    meetAssistPrice: meetAssistPrice.pickup.meetAssistBasePrice,
                                  })
                                }
                              >
                                <div className="d-flex gap-2 align-items-center h-100">
                                  {additionalInformation.meetAssist[0]
                                      .meetAssistName === "meetAssist"
                                    ? <RadioSelectedIcon />
                                    : <RadioUnselectedIcon />}
                                  <div className="col">
                                    <p className="fw-bold m-0">Meet & Assist</p>
                                    <p className="m-0">{`${meetAssistPrice.pickup.meetAssistBasePrice.toLocaleString()} JPY`}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* MEET ASSIST VIP */}
                            <div className="col-4 ">
                              <div
                                className="border-gold rounded p-3 pointer"
                                style={{ height: "100px" }}
                                onClick={() =>
                                  handleMeetAndAssist("arrival", {
                                    meetAssistType: "arrival",
                                    meetAssistName: "vipMeetAssist",
                                    meetAssistPrice:
                                      meetAssistPrice.pickup.vipMeetAssistBasePrice +
                                      (Object.values(bookingData.pax).reduce(
                                        (sum, value) => sum + value,
                                        0
                                      ) > 1
                                        ? (Object.values(bookingData.pax).reduce(
                                          (sum, value) => sum + value,
                                          0
                                        ) -
                                          1) *
                                        meetAssistPrice.pickup.vipMeetAssistAdditionalPrice
                                        : 0),
                                  })
                                }
                              >
                                <div className="d-flex gap-2 align-items-center h-100">
                                  {additionalInformation.meetAssist[0]
                                      .meetAssistName === "vipMeetAssist"
                                    ? <RadioSelectedIcon />
                                    : <RadioUnselectedIcon />}
                                  <div className="col">
                                    <p className="fw-bold m-0">VIP Meet & Assist</p>
                                    <p className="m-0">{`First individual: ${meetAssistPrice.pickup.vipMeetAssistBasePrice.toLocaleString()} JPY`}</p>

                                    <p className="m-0">
                                      {`Additional participants: ${meetAssistPrice.pickup.vipMeetAssistAdditionalPrice.toLocaleString()} JPY/person`}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bg-gold-FFF8E8 px-3 py-2 rounded mb-3">
                            <p className="m-0 fw-bold fs-12">
                              CANCELLATION POLICY FOR VIP MEET & ASSIST SERVICES
                            </p>
                            <p className="m-0">
                              ※ Upon confirmation of your reservation, a 100%
                              cancellation fee will apply.
                            </p>
                            <p className="m-0">
                              ※ Changes to flight details can be accommodated up to 48
                              hours before the scheduled arrival time. Regrettably, we
                              are unable to process any alterations within 48 hours of
                              the scheduled arrival time.
                            </p>
                            <p className="m-0">
                              ※ In the event of a delay to your scheduled flight, we
                              will make the necessary adjustments to our services to
                              accommodate the new arrival time
                            </p>
                          </div>
                          <div className="d-flex align-items-end mt-3 mb-2 gap-3">
                            <div className="col-2">
                              <AdminSelect
                                label="Name Board"
                                mb="mb-0"
                                options={PRONOUNCE_BOARD}
                                onChange={handlePronounceNameBoard}
                                defaultValue={PRONOUNCE_BOARD[0]}
                                value={
                                  PRONOUNCE_BOARD.find(
                                    (option) => option.value === additionalInformation?.pronounceNameBoard
                                  ) || PRONOUNCE_BOARD[0]
                                }
                              />
                            </div>
                            <div className="col">
                              <AdminInput
                                value={additionalInformation?.nameBoard}
                                onChange={handleNameBoard}
                                mb="mb-0"
                                placeholder={"Name Board"}
                              />
                            </div>
                          </div>
                          <p className="fs-12 mb-0">
                            Your chauffeur will hold this name board upon your
                            encounter.
                          </p>
                          <p className="fs-12 mb-0 text-danger">
                            *Kindly note that for the VIP Meet & Assist service, we are
                            unable to display a pick-up sign bearing a company's name.
                          </p>
                        </div>
                      )}

                      {(bookingData?.isToAirport || bookingData?.isToStation) && (
                        <div className="mt-3">
                          <hr />
                          {
                            bookingData?.isAirportTransfer && (
                              <>
                                <p className="mb-2">Dropoff Flight Number</p>
                                <AdminInput
                                  placeholder={"Dropoff Flight Number"}
                                  prefixIcon={<FlightNumberIcon />}
                                  value={additionalInformation?.dropoffFlightNumber}
                                  onChange={handleDropoffFlightNumber}
                                />
                              </>
                            )
                          }

                          <p className="mb-2">Add-on Meet & Assist Services</p>
                          <div className="row mb-2">
                            {/* NONE */}
                            <div className="col-4 ">
                              <div
                                className="border-gold rounded p-3 pointer"
                                style={{ height: "100px" }}
                                onClick={() =>
                                  handleMeetAndAssist("departure", {
                                    meetAssistType: "departure",
                                    meetAssistName: "none",
                                    meetAssistPrice: 0,
                                  })
                                }
                              >
                                <div className="d-flex gap-2 align-items-center h-100">
                                  {additionalInformation.meetAssist[1]
                                      .meetAssistName === "none"
                                    ? <RadioSelectedIcon />
                                    : <RadioUnselectedIcon />}
                                  <div className="col">
                                    <p className="fw-bold m-0">None</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* MEET ASSIST */}
                            <div className="col-4 ">
                              <div
                                className="border-gold rounded p-3 pointer"
                                style={{ height: "100px" }}
                                onClick={() =>
                                  handleMeetAndAssist("departure", {
                                    meetAssistType: "departure",
                                    meetAssistName: "meetAssist",
                                    meetAssistPrice: meetAssistPrice.dropoff.meetAssistBasePrice,
                                  })
                                }
                              >
                                <div className="d-flex gap-2 align-items-center h-100">
                                  {additionalInformation.meetAssist[1]
                                      .meetAssistName === "meetAssist"
                                    ? <RadioSelectedIcon />
                                    : <RadioUnselectedIcon />}
                                  <div className="col">
                                    <p className="fw-bold m-0">Meet & Assist</p>
                                    <p className="m-0">{`${meetAssistPrice.dropoff.meetAssistBasePrice.toLocaleString()} JPY`}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* MEET ASSIST VIP */}
                            <div className="col-4 ">
                              <div
                                className="border-gold rounded p-3 pointer"
                                style={{ height: "100px" }}
                                onClick={() =>
                                  handleMeetAndAssist("departure", {
                                    meetAssistType: "departure",
                                    meetAssistName: "vipMeetAssist",
                                    meetAssistPrice:
                                      meetAssistPrice.dropoff.vipMeetAssistBasePrice +
                                      (Object.values(bookingData.pax).reduce(
                                        (sum, value) => sum + value,
                                        0
                                      ) > 1
                                        ? (Object.values(bookingData.pax).reduce(
                                          (sum, value) => sum + value,
                                          0
                                        ) -
                                          1) *
                                        meetAssistPrice.dropoff.vipMeetAssistAdditionalPrice
                                        : 0),
                                  })
                                }
                              >
                                <div className="d-flex gap-2 align-items-center h-100">
                                  {additionalInformation.meetAssist[1]
                                      .meetAssistName === "vipMeetAssist"
                                    ? <RadioSelectedIcon />
                                    : <RadioUnselectedIcon />}
                                  <div className="col">
                                    <p className="fw-bold m-0">VIP Meet & Assist</p>
                                    <p className="m-0">{`First individual: ${meetAssistPrice.dropoff.vipMeetAssistBasePrice.toLocaleString()} JPY`}</p>

                                    <p className="m-0">
                                      {`Additional participants: ${meetAssistPrice.dropoff.vipMeetAssistAdditionalPrice.toLocaleString()} JPY/person`}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bg-gold-FFF8E8 px-3 py-2 rounded mb-3">
                            <p className="m-0 fw-bold fs-12">
                              CANCELLATION POLICY FOR VIP MEET & ASSIST SERVICES
                            </p>
                            <p className="m-0">
                              ※ Upon confirmation of your reservation, a 100%
                              cancellation fee will apply.
                            </p>
                            <p className="m-0">
                              ※ Changes to flight details can be accommodated up to 48
                              hours before the scheduled arrival time. Regrettably, we
                              are unable to process any alterations within 48 hours of
                              the scheduled arrival time.
                            </p>
                            <p className="m-0">
                              ※ In the event of a delay to your scheduled flight, we
                              will make the necessary adjustments to our services to
                              accommodate the new arrival time
                            </p>
                          </div>
                        </div>
                      )}
                    </>
                  )
                }

                <div className="d-flex align-items-end mt-4 mb-2 gap-3">
                  <div className="col-2">
                    <AdminSelect
                      label="Passenger’s Name"
                      mb="mb-0"
                      options={PRONOUNCE}
                      onChange={handlePronouncePassangerName}
                      defaultValue={PRONOUNCE[0]}
                      value={
                        PRONOUNCE.find(
                          (option) => option.value === additionalInformation?.pronounce
                        ) || PRONOUNCE[0]
                      }
                    />
                  </div>
                  <div className="col">
                    <AdminInput
                      value={additionalInformation?.passengerName}
                      onChange={handlePassangerName}
                      mb="mb-0"
                      placeholder="Passenger's Name"
                    />
                  </div>
                </div>

                {/* CHILD SEAT */}
                {["child", "toddler", "infant", "baby"].some(
                  (key) => bookingData?.pax[key] > 0
                ) && (
                    <div className="">
                      <div className="d-flex mt-4 justify-content-between">
                        <p className="tw:m-0!">Child Seats & Booster Seats</p>
                        <p className="tw:m-0!">1,100 JPY</p>
                      </div>
                      <p className="fs-12">
                        *The images shown are for illustration purposes only and may
                        not be an exact representation of the product
                      </p>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="border rounded p-3">
                            <img
                              src={"https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fe/infant-seat.svg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAWV6JMFK3HVVRF3X5%2F20250227%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Date=20250227T134834Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjED4aDmFwLW5vcnRoZWFzdC0xIkcwRQIhALtqo3cZLGCW5O5D3yOj4DEm336QnuXyxG9d1SkUBluWAiBglXwiYpK0cGbKdTqWZ6Ku4kHOp%2FvocwTF%2BfhneOPK6SqJAwh3EAEaDDQ1OTQ0Njk1NDY3OCIMDtdLjfZy2vN3VAgHKuYCu8b71nC0kzK5MAJ%2Fz3uTlXSmXMdqe8VHlK2NQVPJdDao4V5srHlAytYKB1JUdA0mO%2Fbw7x%2F6CiJU55StTCiqmHkfIWOpH%2FG2A91GKufj2%2F3wfnjbnUfOhKAgMmJqPU5nWN0%2BPTjQjNmF%2FSMTxnmXML094d2%2BPiOgyKGEjnHrnt4wW7ppjE%2Bk8Puqr2hi3%2BAfYjzzZrxe6uVqQlC6D0kT0g0zzlBHNFpMCZc997s24gRf%2BRN7P8i7GlfdzsX%2F9fKukQExolJ50W8pKJBOTDRmqJ837F9pPqsIHfUSh0nbBJlOciZixpplB4rtM52hN9iQZJEZmhAx%2FqzDauETQADVKhITZmU2aM7%2FuDZMIGV3B2O%2FaiaXzG6LA5xxkO59WlODOsHGP%2BkRICfmryEbYa%2BNev3%2BhV1Valk8LZBzDAtAamNTzLKIZM43g4i4gbk4GORPfoax07DYIuNIIMCrKPM4Dm8TOu4LMTCX1oG%2BBjqzAu%2FYyYWNdJAXeSh2Dk2sp1fnsHyeMOMCadz6NAzpxK99PfWKCZvadD%2BAKWpS37fFGL1dFAjvo%2F73W%2FQD%2FC2%2FdH9ADseQoPeoLH6KDgtwigcuBU7VIQ6jnH3RV3LRtpsOawkqDP%2F7Zw8WJC5hcgwG7ssrEDq%2FM%2Bmb%2Fekf%2BfEH4mAwrjoYKUYXuH8SXgbdqCy46Z6Q0KXDTLdf9erH2ivT6Qnjl5iBzsADZBSHY5ORnUzNyTCBWZthcC2HKlAW87RiAtsHsiI9KG5YplrLv02QiPJSnCgptf4CyKwj5egdittsIEkd%2F9qtKq286WkvPrqhO4GkjVF%2Fcax3ylTyT26BKf2IYcvfYAQU%2B4TEVy34u%2FqQdn6WZeUXMoFl03L%2FHxoFvVpDDahzJ0fNfG9ootd0YtA9ooo%3D&X-Amz-Signature=77162c891e8b0d79b5529206c2a83f5cd456a60c0db374415b55436312999501&X-Amz-SignedHeaders=host&response-content-disposition=inline"}
                              className="mb-3"
                              alt=""
                              srcSet=""
                              style={{ height: "121 px" }}
                            />
                            <p
                              className="noto mb-1 fs-8"
                              style={{ letterSpacing: "3px" }}
                            >
                              CHILD SEAT
                            </p>
                            <h5>Baby</h5>
                            <p className="fs-12 mb-0 text-A7A7A7">
                              Usage Recommendation
                            </p>
                            <p className="fs-12">For babies</p>
                            <div className="d-flex gap-4 align-items-center">
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() => {
                                  if (
                                    additionalInformation.childSeat[3]
                                      .childSeatCount > 0
                                  ) {
                                    handleChildSeat(
                                      "Baby",
                                      additionalInformation.childSeat[3]
                                        .childSeatCount - 1
                                    );
                                  }
                                }}
                              >
                                <i className="bi bi-dash d-flex align-items-center justify-content-center"></i>
                              </button>
                              <p className="m-0">
                                {additionalInformation.childSeat[3].childSeatCount}
                              </p>
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() =>
                                  handleChildSeat(
                                    "Baby",
                                    additionalInformation.childSeat[3]
                                      .childSeatCount + 1
                                  )
                                }
                              >
                                <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="border rounded p-3">
                            <img
                              src={"https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fe/baby-seat.svg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAWV6JMFK3CSJMXQOF%2F20250227%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Date=20250227T134815Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjED4aDmFwLW5vcnRoZWFzdC0xIkYwRAIgLd%2BvQ0fQwKv9l%2FaWQN%2F3yzt0z%2BVlPlcYAdeMFd5PVMcCIDaSCHu0YuxDf9TcyI1Sw6tvtUL0TlRvi8MApB2NxBwYKokDCHcQARoMNDU5NDQ2OTU0Njc4IgzF5AUkK17cWR5XQuMq5gIbRgOGS6%2BetjOs4OjNrWynkcRzv6Ge7dDE602quOx9KpJ%2FnzjygGlk%2FUNQOVf8ECSZRYyVo%2B6I2z4F%2BNvp1VE8mZPsx7V%2FIu7u6O39IgYOxUhV57stIYDK%2BZ8bFWRIiT0bH3CjD0FMuNOuLeuUghuAmi%2B%2B79BpRD15hs5NRrIU4NtMG7kdA%2FOb%2FypWFImMQ5i4ZYzyGBpfpxn46x1PQIsatyEkj3FmcXhPXPDdFx929TI5eyfLhbOGlgGGwMl9B%2F6cHjuGno6%2BlO0sJO%2BVSty2emVikvvJ2HT7l6aPpq6S7HeW4mX6nlBQUPMtkD8SwFRLXgqqhTv9o5VwAtlJ8rw0waSua%2FgZXDFh1LC79gGnTsyOzFeqPMLYaai0XBYG5iyUKZwUCL2BG9Vpwju0%2FNZvhBayePKPDICZ0AcSukSVnWZcGD%2BMmWdvGNsbHpei8m7hwmpMwNqSUG5LtLXi76VJZL5I%2FuzfMJfWgb4GOrQCvvXVQKHjxfOG7aMkfxSgM9OFdDxcKkqZvT7AGW9%2FUFOGHJNQuemhXbF8EKOIrgspYNv3NJs5KUavCUuzV7O3y3jhm2NpkjchPzKPwFnbN%2B9LgacpzIB2cAqU1omHMvxEq%2FVkys9v%2Bvb5Ybo%2BayPVE9De2R0dJWB3IIU4AMzvoW0NQrDdYdyc5oeGgpUkLidjjEKfs1Amw%2FLLlKtPzncjfTPmFEAHAMQiUEFxiUB8LsyRrEvdp5jqG8jC1LAQmlNrfZB0evsZ%2FE9fO6O4AFdwkqXOg%2Fb1jRxZXdT%2BUMaU3u47Awg77DKpi4PYDw7fy5uEr1WWnoSSjgtQSKVrlrFS6Y5senxK8b4xqx02Q7GH7TLPrsv2LT%2BYuaNkeOu1Ws9Ri2FjDDXvhvC8V5WuxZLpgslXxBg%3D&X-Amz-Signature=7c70fa1032a30fec239f53b4b10125e1b2e5f83d5230f1e0f7731d8391bd1185&X-Amz-SignedHeaders=host&response-content-disposition=inline"}
                              className="mb-3"
                              alt=""
                              srcSet=""
                              style={{ height: "121 px" }}
                            />
                            <p
                              className="noto mb-1 fs-8"
                              style={{ letterSpacing: "3px" }}
                            >
                              CHILD SEAT
                            </p>
                            <h5>For Infant</h5>
                            <p className="fs-12 mb-0 text-A7A7A7">
                              Usage Recommendation
                            </p>
                            <p className="fs-12">For children from 0-2 years</p>
                            <div className="d-flex gap-4 align-items-center">
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() => {
                                  if (
                                    additionalInformation.childSeat[0]
                                      .childSeatCount > 0
                                  ) {
                                    handleChildSeat(
                                      "Infant",
                                      additionalInformation.childSeat[0]
                                        .childSeatCount - 1
                                    );
                                  }
                                }}
                              >
                                <i className="bi bi-dash d-flex align-items-center justify-content-center"></i>
                              </button>
                              <p className="m-0">
                                {additionalInformation.childSeat[0].childSeatCount}
                              </p>
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() =>
                                  handleChildSeat(
                                    "Infant",
                                    additionalInformation.childSeat[0]
                                      .childSeatCount + 1
                                  )
                                }
                              >
                                <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="border rounded p-3">
                            <img
                              src={"https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fe/toddler-seat.svg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAWV6JMFK3JX7IXI4V%2F20250227%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Date=20250227T134946Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjED4aDmFwLW5vcnRoZWFzdC0xIkcwRQIgWHk9zjLQcPiFQdNcoRiX3Kpl4ot9oW6ggxW4MgbZdRsCIQDk2zqbs1R9nYCAj2Zu6Ul40Jpex3wsTGF1sq1X6%2BSZHiqJAwh3EAEaDDQ1OTQ0Njk1NDY3OCIMwlPJRK6BGx8gURRPKuYCjrbr2DdbY7y2oap3s2LSiZGa5rDvJ4ExK9LRFwoUKERvm8u3nZ1b%2FZAFPMlSqBjF0GxybF2CjPMg1xv%2Bo2lsIeLbivpxjzrvvnAqO049SIUGLSit1ybD0irZoRScWB9nYV5id89ClziG94KfQ3d%2BbPUEgv1FwZwbopChyUtljpvDrBmQaEhpscMQYvmtKD9O%2BLZXd56MT8ZoJDHFf3Z6BgWlnBc8479GL%2Bt0yCH83%2B0UdBy8rIk68xZoPG9be1bdiTnHe5MM%2FhEMUWqnA5Xa7juIdrpW5zqyZJRezH8JQDJqc%2FkcLuSV0I%2FbWfXKAKinrRkodQx12eY0cA6dkux%2B19h8vJ4sDWFF6oV0YVcdlvSf%2FyVumqyI49kGBzx2bXO6wTQLLMmquPnc8g9BRQO4N2KEGCoCn5ZXde1R28rxuU85JxxoO3SFtndTvLkdmjufvYyAvgqITUYNJ%2FZL0USSRHLlrA0ozzCX1oG%2BBjqzAvLYY9ph7gbXaSsQ3SeLvWkvtRHlwxBvNgghkT%2FA4ht5p6CycxwE9twQEikYkTW3go67BYTEmm3RFV17Jn0%2B1h6Vrs8VzOIqjQckdAIab1KMtfoImBlIudEGVneunryKiT1LKduzsSLDjUh2DgRYqhjI0MBjly7NotXAKW%2FEQMVS4PVKmJrcu29djtPpzFJGmSk39wrJ3qYq8qOW9NdFfUWU1O0xIxa2WotJ9yIeEBwus3jwo5V8QKSpOrmKl4RH%2FLfJuW882t54Zd8DOWt33qjjBqPXbWei90lxfXmer7JoGDAPBIhxfLCB8WC%2FhBjLVXOmQoayXy8YJ9s0lb9PznmI8t7VQdpXhgT%2F5brQUIOEpgL2KPGj6H7QBeMgC6z9AELrfnXVFW3kKnpXA5h2ifRI%2F%2BU%3D&X-Amz-Signature=ca51b6f977ab1f22045ed0f215f45796042cdfe43d57021fb6b1ea9c6c73f481&X-Amz-SignedHeaders=host&response-content-disposition=inline"}
                              className="mb-3"
                              alt=""
                              srcSet=""
                              style={{ height: "121 px" }}
                            />
                            <p
                              className="noto mb-1 fs-8"
                              style={{ letterSpacing: "3px" }}
                            >
                              CHILD SEAT
                            </p>
                            <h5>Toddler</h5>
                            <p className="fs-12 mb-0 text-A7A7A7">
                              Usage Recommendation
                            </p>
                            <p className="fs-12">For children from 1 - 3 Years</p>
                            <div className="d-flex gap-4 align-items-center">
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() => {
                                  if (
                                    additionalInformation.childSeat[1]
                                      .childSeatCount > 0
                                  ) {
                                    handleChildSeat(
                                      "Toddler",
                                      additionalInformation.childSeat[1]
                                        .childSeatCount - 1
                                    );
                                  }
                                }}
                              >
                                <i className="bi bi-dash d-flex align-items-center justify-content-center"></i>
                              </button>
                              <p className="m-0">
                                {additionalInformation.childSeat[1].childSeatCount}
                              </p>
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() =>
                                  handleChildSeat(
                                    "Toddler",
                                    additionalInformation.childSeat[1]
                                      .childSeatCount + 1
                                  )
                                }
                              >
                                <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="border rounded p-3">
                            <img
                              src={"https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fe/child-seat.svg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAWV6JMFK3FUIIY4L6%2F20250227%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Date=20250227T134508Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjED4aDmFwLW5vcnRoZWFzdC0xIkgwRgIhAPfYYO2U%2Bf2AZBrFFAd6NMQAGH%2FAff6PG2Pnw39kmiCbAiEAp42JrOcXjn5pWlb58WSJF1sCUWW2nUwh5XF5V7OnE8UqiQMIdxABGgw0NTk0NDY5NTQ2NzgiDNKPfBx%2FL1WUN1%2FW3irmAs%2BiEC6q5ydU6VtnVOVfCEdRCRZozq8h7yMBzMa5XLfzlZA1O6bi293WelgavKw9Mw5jW0Uj7f9wBtwzV7CoIrnbcYt3KoTh%2B9dy0%2BPnqTJqDz4mH7lJ%2BDE6uZJ6VYkz53pvq3lqQsP4KmOvTwkj%2B9yBF8m97PQlYbfQweussnZA1JepcKCAyuwpeklt4Vhn4hXkzRyNTN7RJnVRc8vIbVdyjXKiQXjHGy0XbQJKClZbD5%2FvSfz2m1O%2FjuRMj0PrrlrLgrghi1M6lWUhc%2BHsVdRm5JTYYafKo%2FmeE96WBaIT3gxfeISlEaZCtcQjnXm78wb1mPAm0hOIzMWZZ4bGkc7HE32wZ49BfYPqLcBNSlMpkyPdzRBO3L2ZVBQ44VSt9CiKfqxMoyewSzTz5yMuOulNDxkRDq2M6Ek9%2BdW15fQWBz%2B0cW2ll8InXxA%2F4FiBvBsOlFlR70xDloOfaq3c%2BBwjb5dltsswl9aBvgY6sgK0xmjW14Qu4qy9ADmH5mTt0fwZRr4q4VmqpJ2s20GTtq87nRSy8OE7YXN%2FJUoF2MHnUQK6hqJ2VqqHSTGI5f63zHsU5Agraty4mrw7I%2FzJfUtSC57m4YHT2IZ6jw1%2BVu6Ipk%2FBdVUUvFY5Rli8RgsswVwN4rWWt8IZ6etklapLwMMTfWOKHBeIozkYxrh29jBboFjzl1vFCNVV93Za0tsLt8XgvHS7sHUy9E%2F%2BHBAszE2KrqKOxTwAIq9rCZWPkvgI%2Fimy3rLfGGwRPEVc5DnwiUy73nZEIeRBWR1RAUdWHRNNsr3%2BulFizYyc7%2B1IXJiPQApUNlCVAHRWreEao8Xtf4jwpF%2FES4Pm1CKoZSvLx%2FGuore2pG29C26Ec%2BLjSrgt%2FCNr5yQZ9LjS20fSjfY74Ss%3D&X-Amz-Signature=0aad458c4c69024bb60b3a95a00eb451bf00c20bcf44aab8b7e5407b018ca0e4&X-Amz-SignedHeaders=host&response-content-disposition=inline"}
                              className="mb-3"
                              alt=""
                              srcSet=""
                              style={{ height: "121 px" }}
                            />
                            <p
                              className="noto mb-1 fs-8"
                              style={{ letterSpacing: "3px" }}
                            >
                              CHILD SEAT
                            </p>
                            <h5>Child</h5>
                            <p className="fs-12 mb-0 text-A7A7A7">
                              Usage Recommendation
                            </p>
                            <p className="fs-12">For children from 4 - 11 Years</p>
                            <div className="d-flex gap-4 align-items-center">
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() => {
                                  if (
                                    additionalInformation.childSeat[2]
                                      .childSeatCount > 0
                                  ) {
                                    handleChildSeat(
                                      "Child",
                                      additionalInformation.childSeat[2]
                                        .childSeatCount - 1
                                    );
                                  }
                                }}
                              >
                                <i className="bi bi-dash d-flex align-items-center justify-content-center"></i>
                              </button>
                              <p className="m-0">
                                {additionalInformation.childSeat[2].childSeatCount}
                              </p>
                              <button
                                type="button"
                                className="btn btn-circle btn-outline-dark"
                                onClick={() =>
                                  handleChildSeat(
                                    "Child",
                                    additionalInformation.childSeat[2]
                                      .childSeatCount + 1
                                  )
                                }
                              >
                                <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <div className="mb-5">
                <h5 className="mt-4">4. Notes (displayed on the quotation)</h5>
                <AdminTextArea
                  value={note}
                  placeholder={"Itinerary details or additional notes"}
                  onChange={handleNote}
                />
              </div>
              <div className="">
                <h5 className="mt-4">Transfer Recurrence</h5>
                <div className="d-flex gap-3 my-3">
                  <div
                    className={`
                      ${addTransferType === "one_time" ? "border border-gold" : "border"} 
                      tw:!rounded 
                      tw:!p-2 
                      tw:!cursor-pointer
                    `}
                    style={{ height: "50px" }}
                    onClick={() => handleChangeAddTransferType("one_time")}
                  >
                    <div className="d-flex gap-3 px-3 align-items-center h-100">
                      {addTransferType === "one_time"
                        ? <RadioSelectedIcon />
                        : <RadioUnselectedIcon />}
                      <p
                        className={`m-0 p-0 pointer ${addTransferType === "one_time" && "fw-bold"} `}
                      >
                        One-Time
                      </p>
                    </div>
                  </div>
                  <div
                    className={`
                      ${addTransferType === "recurring" ? "border border-gold" : "border" } 
                      tw:!rounded 
                      tw:!p-2
                      tw:!cursor-pointer
                    `}
                    onClick={() => handleChangeAddTransferType("recurring")}
                    style={{ height: "50px" }}
                  >
                    <div className="d-flex gap-3 px-3 align-items-center h-100">
                      {addTransferType === "recurring"
                        ? <RadioSelectedIcon />
                        : <RadioUnselectedIcon />}
                      <p
                        className={`m-0 p-0 pointer ${addTransferType === "recurring" && "fw-bold"} `}
                      >
                        Recurring
                      </p>
                    </div>
                  </div>
                </div>
                {addTransferType === "recurring" && (
                  <div className="row mb-3">
                    {recurringTravelDates.map((item, index) => (
                      <div className="col-4 mb-2">
                        <AdminInputDatePicker
                          placeholder="Select Date"
                          prefixIcon={<CalendarAltIcon />}
                          onSelectDate={handleSelectTravelDate}
                          mb={""}
                          name="issueDate"
                          hasIndex={true}
                          index={index}
                          value={
                            recurringTravelDates[index]
                              ? moment(
                                recurringTravelDates[index],
                                "YYYY-MM-DD"
                              ).toDate()
                              : null
                          }
                          suffixIcon={index !== 0 && <CloseIcon color="#666666" size={10} />}
                          onSufixIconClick={() => removeReccuringTravelDate(index)}
                          dateFormat="MMMM d, yyyy (E)"
                        />
                      </div>
                    ))}
                    <div className="col-auto">
                      <div className="d-grid">
                        <button className="bg-gold-light-100 px-4 rounded" style={{ height: "50px" }} onClick={addReccuringTravelDate}>
                          <div className="d-flex justify-content-center align-items-center gap-2">

                            <PlusIcon color="#666666" />
                            <p className="m-0">
                              Add Date
                            </p>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {vehicles.filter(value => value !== null).length > 0 ? parseInt(bookingData?.luggage?.cabinSize + bookingData?.luggage?.checkinSize) > totalMaxLuggage || parseInt(bookingData?.pax?.adult + bookingData?.pax?.child + bookingData?.pax?.toddler + bookingData?.pax?.baby) > totalMaxPessanger ? <></> : <div className="d-grid mt-3">
                <button
                  className="btn btn-primary tw:!py-2 tw:!rounded tw:!text-[#FFFFFF] tw:!h-12"
                  disabled={loadingAddTransfer}
                  onClick={handleSubmitConfirm}
                >
                  {loadingAddTransfer
                    ? "Loading ... "
                    : "Confirm & Calculate Price "}
                </button>
              </div> : <></>}
            </div>
          </div>


          <AdminModal
            show={errorModal}
            size="modal-md"
            centered={true}
            onClose={closeErrorModal}
            title={"ERROR"}
          >
            <h5 className="text-center text-EB001B">
              {errorText}
            </h5>
          </AdminModal>
        </main>
      </Layout>
    </>
  );
};

export default Transfer;
